export function PageHeader({ title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between gap-4" data-testid="page-header">
      <div>
        <h1 className="font-heading font-semibold text-2xl sm:text-3xl tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
